<template>
  <div class="page-course-detail" v-show="isShow && isMounted">
    <div class="left-right-content clearfix">
      <el-breadcrumb class="add-breadcrumb" separator="/" v-if="liveDetail.belongSection == 3">
        <el-breadcrumb-item ><a :href="baseUrl+'/nAnimateMake?plate='+liveDetail.belongSection">动画制作</a></el-breadcrumb-item>
        <el-breadcrumb-item ><a :href="baseUrl+'/course?plate='+liveDetail.belongSection">课程</a></el-breadcrumb-item>
        <el-breadcrumb-item>直播</el-breadcrumb-item>
        <!--<el-breadcrumb-item>课程类型</el-breadcrumb-item>-->
      </el-breadcrumb>
      <el-breadcrumb class="add-breadcrumb" separator="/" v-else>
        <el-breadcrumb-item ><a :href="baseUrl+'/nTradition?plate='+liveDetail.belongSection">传统文化</a></el-breadcrumb-item>
        <el-breadcrumb-item ><a :href="baseUrl+'/course?plate='+liveDetail.belongSection">直播</a></el-breadcrumb-item>
        <el-breadcrumb-item>直播</el-breadcrumb-item>
        <!--<el-breadcrumb-item>课程类型</el-breadcrumb-item>-->
      </el-breadcrumb>
      <div class="c-left">
        <div class="top-info">

          <div
            class="video-wrap"
            :style="{backgroundImage: 'url(' + liveDetail.imgSrc + ')'}"
          >
            <el-button class="mask-all" v-if="!isLogin" @click="showTag(1)"></el-button>
            <el-button class="mask-all" v-else-if="isLogin && live.isSignUp !=1 && loginUserId!=live.creatorId" @click="showTag(2)"></el-button>
            <el-button class="mask-all" v-else @click="toView"></el-button>

            <!--<router-link to="" class="mask-all"></router-link>-->
          </div>
          <div class="infoma">
            <div class="tit-jj">
              <div class="tit">{{liveDetail.title}}</div>
              <div class="jianjie">{{liveDetail.courseIntroduction}}</div>
            </div>
            <div class="more-info">
              <div class="type" v-if="liveDetail.cType">课程类型：{{liveDetail.cType}}</div>
              <div class="type" v-else>课程类型：{{liveDetail.fType}}</div>
              <div class="time">直播时间：{{liveDetail.startTimeStr}} -- {{liveDetail.endTimeStr}}</div>
              <div class="much">{{liveDetail.memberCount}}人报名</div>
            </div>
            <div>
              <div v-if="liveDetail.isPromotionTime!= -1">
                <div class="price">
                  <span v-if=" liveDetail.promotionPrice > 0 ">￥{{liveDetail.promotionPrice}}</span><span v-else>免费</span>
                  <span class="old-price">￥{{liveDetail.coursePrice}}</span></div>
                <div class="acti-time">活动时间：{{liveDetail.promotionStartTimeStr}} -- {{liveDetail.promotionEndTimeStr}}</div>
              </div>
              <div v-else>
                <div class="price"><span v-if=" liveDetail.coursePrice > 0 ">￥{{liveDetail.coursePrice}}</span><span v-else>免费</span></div>
              </div>
            </div>
<!--            status===>:  isLogin{{isLogin}}-->
<!--            status===>:  isSignUp{{live.isSignUp}}-->
<!--            status===>:  loginUserId{{loginUserId}}-->
<!--            status===>:  creatorId{{live.creatorId}}-->
            <!--            status===>:  isPromotionTime{{live.isPromotionTime}}-->
            <div class="btns">
              <el-button size="large" class="btn wgz-btn" v-if="!isLogin" @click="toLog">登录</el-button>
              <el-button size="large" class="btn wgz-btn" v-else-if="isLogin && live.isSignUp !=1 && loginUserId!=live.creatorId" @click="signUp"><span v-if="priceNow >0">立即报名</span><span v-else>观看</span></el-button>
              <el-button size="large" class="btn wgz-btn" v-else @click="toView">观看</el-button>
              <!-- <el-button size="large" class="btn" type="warning">在线咨询</el-button> -->
            </div>
          </div>
        </div>
        <div class="course-detail" ref="lessonItemOne">
          <div class="title">课程详情</div>
          <div class="detail-cont">{{liveDetail.mainContent}}</div>
        </div>
        <div class="course-list-duo" ref="lessonItemTwo" v-show="liveDetail.replayList" >
          <div class="f-title">课程安排</div>
          <list-item
            :showTagType="showTagType"
            :replayList="liveDetail.replayList"
            :isOpen="true"
            :userId="loginUserId"
          />
        </div>

        <!-- 评论 -->
        <div class="pro-work-item clearfix" style="border-top: 5px solid #f6f6f6;" ref="lessonItemThree">
          <div class="item-infoes same-left">
            <talkPart :objType="7" :objId="objId" v-if="isReload && isMounted"
                      :loadShow="true" :isOperate="false" :isHeaderOperate="true"
                      ref="talkPart"></talkPart>
          </div>
        </div>
        <!-- 评论 -->

      </div>
      <div class="c-right">
        <div class="one-item">
          <div class="detail-userinfo" v-if="showUser">
            <router-link :to="{path:'/home', query: {userId:userInfo.userId}}" class="avatar-f"><img :src="userInfo.imgUrl" alt=""></router-link>
            <div class="user-name"><router-link :to="{path:'/home', query: {userId:userInfo.userId}}">{{userInfo.userName}}</router-link></div>
            <div class="chenghao">{{userInfo.signature}}</div>
            <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
              <el-button class="btn wgz-btn" v-if="userInfo.followStatus==0"  @click="doFollow(userInfo.userId)"><i class="el-icon-plus"></i> 关注</el-button>
              <el-button class="btn" v-else-if="userInfo.followStatus==1" @click="undoFollower(userInfo.userId)">已关注</el-button>
              <el-button class="btn" v-else-if="userInfo.followStatus==2" @click="undoFollower(userInfo.userId)">互相关注</el-button>

              <el-button class="btn wgz-btn" v-if="friendStatus == 4"  @click="addFriend()"><i class="el-icon-plus"></i> 加好友</el-button>
              <!--<el-button class="btn" @click="toChart(userInfo.userId)" v-else-if="friendStatus == 2">发消息</el-button>-->
              <el-button class="btn" v-else-if="friendStatus == 1" style="cursor:auto">请求中</el-button>

            </div>
            <ul class="much-list three clearfix">
              <li>
                <span class="tit">课程</span>
                <span class="count">{{userInfo.courseCount}}</span>
              </li>
              <li>
                <span class="tit">报名</span>
                <span class="count">{{userInfo.courseSin}}</span>
              </li>
              <li>
                <span class="tit">点赞</span>
                <span class="count">{{userInfo.courseLike}}</span>
              </li>

             <!-- <li>
                <router-link target="_blank" :to="{path:'/home/wenzhang', query: {userId:userInfo.userId}}">
                  <span class="tit">文章</span>
                  <span class="count">{{userInfo.archivesCount}}</span>
                </router-link>
              </li>
              <li>
                <span class="tit">阅读</span>
                <span class="count">{{userInfo.viewCount}}</span>
              </li>
              <li>
                <span class="tit">被赞</span>
                <span class="count">{{userInfo.likeCount}}</span>
              </li>-->

            </ul>
            <div class="qianming">{{userInfo.introduction}}</div>
          </div>
        </div>
        <div class="one-item" v-if="otherLiveList.length >0">
          <div class="one-title">
            其他直播
            <i class="el-icon-refresh-right shuaxin" @click="other"></i>
          </div>

          <div class="works-list">

            <div class="item" v-for="(item,index) in otherLiveList" :key="index">
              <div class="work-img-f">
                <router-link  :to="{path:'/livedetail',query:{id:item.liveId,plate: item.belongSection}}"  target="_blank">
                <img :src="item.courseThumbnail" alt="">
                <div class="mask"><i class="el-icon-video-play play-icon"></i></div>
                </router-link>
              </div>
              <div class="work-title">{{item.courseName}}</div>
            </div>

          </div>

        </div>
      </div>
    </div>
     <ul class="right-side-btns">
      <li @click="scrollItem(0)">课程详情</li>
      <li @click="scrollItem(1)">课程安排</li>
      <li @click="doShare">分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;享</li>
      <li @click="scrollItem(2)">评&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;论</li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
  import liveApi from '@/api/live'
  import userInfoApi from '@/api/userInfo'
  import homeApi from '@/api/home'
  import talkPart from '@@/pub/talkpart/talkpart'
  import updateTdk from "@/utils/tdk";
  import {mapState} from "vuex";
  import ListItem from './repalyListItem'
  import scrollItemMixin from './minxin'
export default {

  components: {
    talkPart,
    ListItem
  },
  mixins: [scrollItemMixin],
  data () {
    return {
      baseUrl:process.env.config.RRDH_HOST,
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      isShow:false,
      showUser:false,
      isReload:false,
      isLogin:false,
      loginUserId :0,
      objId:0,
      // liveId:0,
      live:{},
      otherLiveParam:{
        creatorId:0,
        liveId:0,
        pageIndex: 1,
        pageSize: 2,
        verifyStatus:'2',
        classificationOf: 14,
      },
      otherLiveList:[],
      otherTotal:0,
      userInfo:{},
      friendStatus:-1,
      priceNow: 0, //当前价格
      showTagType:1,  //1未登录 3 未发布 2 未报名
    }
  },
  computed: {
    ...mapState(["liveDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    let liveId = this.$route.query.id
    return this.fetchData();

  },
  // beforeMount(){
  //   let liveId = this.$route.query.id
  // },
  // destroyed() {
  //   this.$store.commit("SET_LIVE_DETAIL", { detail: null });
  // },
  mounted() {
    const alreadyIncremented = !!this.liveDetail;
    console.log("liveDetail=--------------------------",this.liveDetail)
    if (!alreadyIncremented) {
      this.fetchData().then(
              setTimeout(()=>{
                this.initData()
              },500)
      );
    } else {
      setTimeout(()=>{
        this.initData()
      },500)
    }

  },
  methods:{
    setShowTagType(){
      let thiss = this
      if(thiss.loginUserId!=thiss.live.creatorId && thiss.live.verifyStatus !=2){
        thiss.showTagType = 3
      }else if(thiss.loginUserId!=thiss.live.creatorId && thiss.live.isSignUp !=1){
        thiss.showTagType = 2
      }else{
        thiss.showTagType = 4
      }
    },
    setSeo() {
      this.headTitle = this.liveDetail.title+"——人人动画网【官网】";
      this.headKeywords = this.liveDetail.courseIntroduction;
      let desc = this.liveDetail.mainContent.replace(/<\/?.+?>/g,"").trim()
      this.headDesc =desc.substr(0,150);
    },
    fetchData(){
      this.$loading(true)
      const cookies = this.$ssrContext && this.$ssrContext.cookies
      return this.$store
              .dispatch("FETCH_LIVE_DETAIL", {
                id: this.$route.query.id
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData(){
      let thiss = this
      thiss.live = thiss.liveDetail

      if(thiss.global.isLogin){
        thiss.loginUserId = thiss.global.userModel.id
        thiss.isLogin = true

        let url = '/rrbi/pay/ifPayed?productId=' + thiss.live.courseId + '&orderType=5&time=' + new Date().getMilliseconds();
        thiss.$axios.get(url).then(function (result) {
          if (result.data == 1) {
            thiss.live.isSignUp =result.data
          }else{
            //没有支付信息，查看是否有报名信息
            const formData = new FormData() // 创建form对象
            formData.append('userId', thiss.global.userModel.id)
            formData.append('courseId', thiss.live.courseId)

            liveApi.isSignUp(formData).then(data =>{
              // console.log("data=======eeeeeeeeeeeeeeeeeeeeeeee========",data)
              thiss.live.isSignUp =data
              thiss.setShowTagType();
              thiss.isShow = true
            })
            //thiss.live.isSignUp = 0
          }
          thiss.setShowTagType();
          thiss.isShow = true
          thiss.isMounted = true;
        })
      }else{
        thiss.isShow = true
        thiss.isMounted = true;
      }

      thiss.objId =parseInt(thiss.live.courseId)
      thiss.isReload = true
      //作者信息
      //console.log("thiss.live=====",thiss.live.creatorId)
      userInfoApi.select(thiss.live.creatorId).then(reUser => {
        //console.log("reUs=========",reUser)
        thiss.userInfo = reUser.response
        thiss.showUser = true
      })
      thiss.other()
      thiss.getPriceNow()
    },

    getPriceNow(){
      let thiss = this

      let isPromotionTime = thiss.live.isPromotionTime
      let price = 0;

      //-1代表活动结束或者没有活动,不做时间区间验证
      if(isPromotionTime != -1){
        let now = new Date().getTime();
        let sT = new Date(thiss.live.promotionStartTime).getTime()
        let eT = new Date(thiss.live.promotionEndTime).getTime()
        if(sT< now && eT > now){
          isPromotionTime = 1
        }else if(sT > now){
          isPromotionTime = 0
        }else{
          isPromotionTime = -1
        }
      }
      if(isPromotionTime ==0){
        price = thiss.live.coursePrice
      }else{
        if(isPromotionTime==1){
          price = thiss.live.promotionPrice
        }else{
          price = thiss.live.coursePrice
        }
      }

      thiss.priceNow = price
    },

    other(){
      let this_ = this
      this_.otherLiveParam.creatorId =this_.live.creatorId
      this_.otherLiveParam.liveId = this_.live.liveId

      liveApi.getOtherList(this_.otherLiveParam).then(reOther => {
        this_.otherLiveList= reOther.list
        this_.otherTotal= reOther.total

        if(this_.otherLiveParam.pageIndex == Math.ceil(this_.otherTotal/this_.otherLiveParam.pageSize) ){
          this_.otherLiveParam.pageIndex =1
        }else{
          this_.otherLiveParam.pageIndex = this_.otherLiveParam.pageIndex+1
        }
      })
    },


    toLog(){
      this.$router.push({
        path:'/login?callback=' + window.location.href,
      })

    } ,
    showTag(type){
      if(type == 1){
        this.$message({
          message: "请登录",
          type: 'error'
        });
      }
      if(type == 2){
        if(this.priceNow > 0){
          this.$message({
            message: "请报名",
            type: 'error'
          });
        }else{
          this.signUp()
        }
      }
      return false
    },
    signUp(){
      let _this=this;
      let isPromotionTime = _this.live.isPromotionTime
      let price = 0;

      //-1代表活动结束或者没有活动,不做时间区间验证
      if(isPromotionTime != -1){
        let now = new Date().getTime();
        let sT = new Date(_this.live.promotionStartTime).getTime()
        let eT = new Date(_this.live.promotionEndTime).getTime()
        if(sT< now && eT > now){
          isPromotionTime = 1
        }else if(sT > now){
          isPromotionTime = 0
        }else{
          isPromotionTime = -1
        }
      }

      if(isPromotionTime ==0){
        this.$confirm('活动未开始，是否确认原价购买？').then(_ => {
          price = _this.live.coursePrice
          _this.toPay(price)
        }).catch(_ => {
          console.log('取消 catch',_)
        })
      }else{
        if(isPromotionTime==1){
          price = _this.live.promotionPrice
        }else{
          price = _this.live.coursePrice
        }
        _this.toPay(price)
      }
    },
    toPay(price){
      let _this=this;
      if(price == '0'){
        let signUpUrl='/rrbi/livefront/signUp?courseId='+_this.live.courseId+'&userId='+_this.loginUserId+
                '&time='+new Date().getMilliseconds();
        _this.$axios.get(signUpUrl).then(function(signResult){
          if(signResult.data.code==1){
            _this.$message({
              message: '报名成功',
              type: 'success'
            });
            _this.toView()
            window.location.reload();
          }else{
            _this.$message({
              message: signResult.data.message,
              type: 'warning'
            });
          }
        })
      }else{
        _this.$router.push({
          path:'/coursepay',
          query: {id:_this.live.courseId,orderType:5}
        })
      }

    },
    toView(){
      if(this.live.viewUrl == null){
        this.$message.error("直播已结束且暂无回放")
      }else{
        let url = ''
        if(this.loginUserId == this.live.creatorId){
          //讲师
          if(this.liveDetail.statusType ==3){
            url = this.live.publisherUrl+this.userInfo.userId
          }else{
            url =  this.live.publisherUrl+this.userInfo.userName
          }

        }else{
          //学员
          url = this.live.viewUrl
          if(url.indexOf("&viewername=7") >0){
            url = url.replace("viewername=7","viewername="+this.loginUserId)
          }else{
              if(this.liveDetail.statusType ==3){
                  url = url + this.loginUserId
              }else {
                  url = url +this.global.userModel.name
              }


          }
        }

         window.open(url,"_blank")
        //window.location.href=
      }

      //window.location.href=this.live.viewUrl
    },
    doFollow(userId){
      let this_ = this
      homeApi.follower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status >= 1) {
          this_.userInfo.followStatus=status
          this_.$message.success("关注成功")
        } else {
          this_.$message.error("关注失败")
        }
      })
    },
    undoFollower(userId) {
      let _this = this;
      homeApi.undoFollower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status == 1) {
          _this.userInfo.followStatus=0
          _this.$message.success("取消成功")
        } else {
          _this.$message.error("取消失败")
        }
      })
    },
    getFriendStatus(){
      let _this=this;
      let url="/rrbi/friends/getFriendStatus?userId="+_this.live.creatorId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        _this.friendStatus = result.data
      })
    },
    addFriend() {
      let _this = this;
      if (_this.global.isLogin) {
        let url = '/rrbi/friends/add/' + _this.live.creatorId + "?ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
         // console.log(result)
          if (result.data.response.code == 1) {
            _this.$message.success(result.data.response.msg)
            _this.friendStatus = 1
          } else {
            _this.$message.error(result.data.response.msg)
          }
        })
      }
    },
    doShare(){
      this.$refs.talkPart.share();
    }
  }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
@import "./detail.less";
.page-course-detail {
  padding-top: @NAVHEIGHT;
}
@media screen and (max-width: 750px) {
  .right-side-btns{
    display: none;
  }
}
</style>
